import script from "./sample-regist.vue?vue&type=script&setup=true&lang=js"
export * from "./sample-regist.vue?vue&type=script&setup=true&lang=js"

import "./sample-regist.vue?vue&type=style&index=0&id=113bb634&lang=scss&scoped=true"
import "./sample-regist.vue?vue&type=style&index=1&id=113bb634&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-113bb634"]])

export default __exports__